import { RedirectingScenario, RedirectingScenarioCondition } from "@/router/redirectingRules";

export const redirectToBuildingsListIfUserIsLoggedInScenario: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
  ],
  redirectTo: 'BuildingList',
  afterSuccess: undefined,
  saveQuery: false,
  saveParams: false,
};

export const redirectToLoginIfUserIsNotLoggedInScenario: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_NOT_LOGGED_IN,
  ],
  redirectTo: 'Welcome',
  afterSuccess: undefined,
  saveQuery: false,
  saveParams: false,
};

export const redirectToOrganizationDetailsIfUserDidNotSetThemYet: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
    RedirectingScenarioCondition.USER_HAS_NO_ORGANIZATION,
  ],
  redirectTo: 'FillOrganizationDetails',
  afterSuccess: undefined,
  saveQuery: true,
  saveParams: false,
};

export const redirectToBuildingsListIfUserDidNotSelectBuilding: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
    RedirectingScenarioCondition.USER_HAS_ORGANIZATION,
    RedirectingScenarioCondition.USER_DID_NOT_SELECT_BUILDING,
  ],
  redirectTo: 'BuildingList',
  afterSuccess: undefined,
  saveQuery: false,
  saveParams: false,
};

export const redirectToLoginIfUserNotAuthorizedForOauth: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_NOT_LOGGED_IN,
  ],
  redirectTo: 'Welcome',
  afterSuccess: 'AuthorizeExternalServicePage',
  saveQuery: true,
  saveParams: true,
};

export const redirectToOrganizationDetailsIfUserHasNoOneForOauth: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
    RedirectingScenarioCondition.USER_HAS_NO_ORGANIZATION,
  ],
  redirectTo: 'FillOrganizationDetails',
  afterSuccess: 'AuthorizeExternalServicePage',
  saveQuery: true,
  saveParams: true,
};

export const redirectToBuildingIfBuildingIsSelected: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
    RedirectingScenarioCondition.USER_HAS_ORGANIZATION,
    RedirectingScenarioCondition.USER_SELECTED_BUILDING,
  ],
  redirectTo: 'Building',
  afterSuccess: undefined,
  saveQuery: false,
  saveParams: false,
};

export const redirectToBuildingStructurePageIfUserDidNotEnableScenarioFeature: RedirectingScenario = {
  conditions: [
    RedirectingScenarioCondition.USER_IS_LOGGED_IN,
    RedirectingScenarioCondition.USER_HAS_ORGANIZATION,
    RedirectingScenarioCondition.USER_SELECTED_BUILDING,
    RedirectingScenarioCondition.USER_DID_NOT_ENABLE_SCENARIOS_FEATURE
  ],
  redirectTo: 'BuildingStructure',
  afterSuccess: undefined,
  saveQuery: false,
  saveParams: false,
};
